/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {DefaultItemTitleComponent} from '../../base/default-item-title.component';
import {DefaultItemTitleRouteComponent} from '../../base/default-item-title-route.component';
import {AppSharedModule} from '../app-shared.module';
import {RouteTwoPanelBottomLayoutComponent, RouteTwoPanelLayoutComponent} from './route-two-panel-layout.component';
import {ContainerStateTitleComponent, EmptyRouteViewComponent, StaticRouteTitleComponent} from './html/route-view-components';
import {StateTitleComponent} from './html/state-title.component';

const ROUTE_VIEWS = [
  ContainerStateTitleComponent,
  DefaultItemTitleComponent,
  DefaultItemTitleRouteComponent,
  EmptyRouteViewComponent,
  RouteTwoPanelBottomLayoutComponent,
  RouteTwoPanelLayoutComponent,
  StateTitleComponent,
  StaticRouteTitleComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    TranslateModule,
    UIRouterModule
  ],
  declarations: ROUTE_VIEWS,
  exports: ROUTE_VIEWS
})
export class RouteViewsModule {
}
